/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RedirectImport } from './routes/redirect'
import { Route as ProtectedImport } from './routes/_protected'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as ProtectedRedirectToCustomerPortalImport } from './routes/_protected/redirect-to-customer-portal'
import { Route as ProtectedPurchaseImport } from './routes/_protected/purchase'
import { Route as ProtectedDashboardImport } from './routes/_protected/dashboard'
import { Route as ProtectedTaxImport } from './routes/_protected/_tax'
import { Route as ProtectedLeasingImport } from './routes/_protected/_leasing'
import { Route as ProtectedImportImport } from './routes/_protected/_import'
import { Route as ProtectedEquipmentImport } from './routes/_protected/_equipment'
import { Route as ProtectedDealershipImport } from './routes/_protected/_dealership'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AuthSignUpIndexImport } from './routes/_auth/sign-up.index'
import { Route as AuthForgotPasswordIndexImport } from './routes/_auth/forgot-password.index'
import { Route as AuthSignUpTokenImport } from './routes/_auth/sign-up.$token'
import { Route as AuthForgotPasswordTokenImport } from './routes/_auth/forgot-password.$token'
import { Route as ProtectedTaxTaxIndexImport } from './routes/_protected/_tax/tax.index'
import { Route as ProtectedLeasingLeasingIndexImport } from './routes/_protected/_leasing/leasing.index'
import { Route as ProtectedImportImportIndexImport } from './routes/_protected/_import/import.index'
import { Route as ProtectedEquipmentEquipmentIndexImport } from './routes/_protected/_equipment/equipment.index'
import { Route as ProtectedDealershipDealershipIndexImport } from './routes/_protected/_dealership/dealership.index'
import { Route as ProtectedTaxTaxCreateImport } from './routes/_protected/_tax/tax.create'
import { Route as ProtectedLeasingLeasingCreateImport } from './routes/_protected/_leasing/leasing.create'
import { Route as ProtectedLeasingLeasingIdImport } from './routes/_protected/_leasing/leasing.$id'
import { Route as ProtectedImportImportCreateImport } from './routes/_protected/_import/import.create'
import { Route as ProtectedImportImportIdImport } from './routes/_protected/_import/import.$id'
import { Route as ProtectedEquipmentEquipmentCreateImport } from './routes/_protected/_equipment/equipment.create'
import { Route as ProtectedDealershipDealershipUsersImport } from './routes/_protected/_dealership/dealership.users'
import { Route as ProtectedDealershipDealershipSubscriptionImport } from './routes/_protected/_dealership/dealership.subscription'
import { Route as ProtectedDealershipDealershipProfileImport } from './routes/_protected/_dealership/dealership.profile'
import { Route as ProtectedDealershipDealershipPaymentMethodsImport } from './routes/_protected/_dealership/dealership.payment-methods'
import { Route as ProtectedDealershipDealershipPaymentHistoryImport } from './routes/_protected/_dealership/dealership.payment-history'
import { Route as ProtectedDealershipDealershipNotificationsImport } from './routes/_protected/_dealership/dealership.notifications'
import { Route as ProtectedTaxTaxIdIndexImport } from './routes/_protected/_tax/tax.$id.index'

// Create/Update Routes

const RedirectRoute = RedirectImport.update({
  path: '/redirect',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRoute = ProtectedImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRedirectToCustomerPortalRoute =
  ProtectedRedirectToCustomerPortalImport.update({
    path: '/redirect-to-customer-portal',
    getParentRoute: () => ProtectedRoute,
  } as any)

const ProtectedPurchaseRoute = ProtectedPurchaseImport.update({
  path: '/purchase',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedDashboardRoute = ProtectedDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedTaxRoute = ProtectedTaxImport.update({
  id: '/_tax',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedLeasingRoute = ProtectedLeasingImport.update({
  id: '/_leasing',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedImportRoute = ProtectedImportImport.update({
  id: '/_import',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedEquipmentRoute = ProtectedEquipmentImport.update({
  id: '/_equipment',
  getParentRoute: () => ProtectedRoute,
} as any)

const ProtectedDealershipRoute = ProtectedDealershipImport.update({
  id: '/_dealership',
  getParentRoute: () => ProtectedRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSignUpIndexRoute = AuthSignUpIndexImport.update({
  path: '/sign-up/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSignUpTokenRoute = AuthSignUpTokenImport.update({
  path: '/sign-up/$token',
  getParentRoute: () => AuthRoute,
} as any)

const AuthForgotPasswordTokenRoute = AuthForgotPasswordTokenImport.update({
  path: '/forgot-password/$token',
  getParentRoute: () => AuthRoute,
} as any)

const ProtectedTaxTaxIndexRoute = ProtectedTaxTaxIndexImport.update({
  path: '/tax/',
  getParentRoute: () => ProtectedTaxRoute,
} as any)

const ProtectedLeasingLeasingIndexRoute =
  ProtectedLeasingLeasingIndexImport.update({
    path: '/leasing/',
    getParentRoute: () => ProtectedLeasingRoute,
  } as any)

const ProtectedImportImportIndexRoute = ProtectedImportImportIndexImport.update(
  {
    path: '/import/',
    getParentRoute: () => ProtectedImportRoute,
  } as any,
)

const ProtectedEquipmentEquipmentIndexRoute =
  ProtectedEquipmentEquipmentIndexImport.update({
    path: '/equipment/',
    getParentRoute: () => ProtectedEquipmentRoute,
  } as any)

const ProtectedDealershipDealershipIndexRoute =
  ProtectedDealershipDealershipIndexImport.update({
    path: '/dealership/',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedTaxTaxCreateRoute = ProtectedTaxTaxCreateImport.update({
  path: '/tax/create',
  getParentRoute: () => ProtectedTaxRoute,
} as any)

const ProtectedLeasingLeasingCreateRoute =
  ProtectedLeasingLeasingCreateImport.update({
    path: '/leasing/create',
    getParentRoute: () => ProtectedLeasingRoute,
  } as any)

const ProtectedLeasingLeasingIdRoute = ProtectedLeasingLeasingIdImport.update({
  path: '/leasing/$id',
  getParentRoute: () => ProtectedLeasingRoute,
} as any)

const ProtectedImportImportCreateRoute =
  ProtectedImportImportCreateImport.update({
    path: '/import/create',
    getParentRoute: () => ProtectedImportRoute,
  } as any)

const ProtectedImportImportIdRoute = ProtectedImportImportIdImport.update({
  path: '/import/$id',
  getParentRoute: () => ProtectedImportRoute,
} as any)

const ProtectedEquipmentEquipmentCreateRoute =
  ProtectedEquipmentEquipmentCreateImport.update({
    path: '/equipment/create',
    getParentRoute: () => ProtectedEquipmentRoute,
  } as any)

const ProtectedDealershipDealershipUsersRoute =
  ProtectedDealershipDealershipUsersImport.update({
    path: '/dealership/users',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedDealershipDealershipSubscriptionRoute =
  ProtectedDealershipDealershipSubscriptionImport.update({
    path: '/dealership/subscription',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedDealershipDealershipProfileRoute =
  ProtectedDealershipDealershipProfileImport.update({
    path: '/dealership/profile',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedDealershipDealershipPaymentMethodsRoute =
  ProtectedDealershipDealershipPaymentMethodsImport.update({
    path: '/dealership/payment-methods',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedDealershipDealershipPaymentHistoryRoute =
  ProtectedDealershipDealershipPaymentHistoryImport.update({
    path: '/dealership/payment-history',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedDealershipDealershipNotificationsRoute =
  ProtectedDealershipDealershipNotificationsImport.update({
    path: '/dealership/notifications',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)

const ProtectedTaxTaxIdIndexRoute = ProtectedTaxTaxIdIndexImport.update({
  path: '/tax/$id/',
  getParentRoute: () => ProtectedTaxRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedImport
      parentRoute: typeof rootRoute
    }
    '/redirect': {
      id: '/redirect'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof RedirectImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_protected/_dealership': {
      id: '/_protected/_dealership'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedDealershipImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/_equipment': {
      id: '/_protected/_equipment'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedEquipmentImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/_import': {
      id: '/_protected/_import'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedImportImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/_leasing': {
      id: '/_protected/_leasing'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedLeasingImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/_tax': {
      id: '/_protected/_tax'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedTaxImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/purchase': {
      id: '/_protected/purchase'
      path: '/purchase'
      fullPath: '/purchase'
      preLoaderRoute: typeof ProtectedPurchaseImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/redirect-to-customer-portal': {
      id: '/_protected/redirect-to-customer-portal'
      path: '/redirect-to-customer-portal'
      fullPath: '/redirect-to-customer-portal'
      preLoaderRoute: typeof ProtectedRedirectToCustomerPortalImport
      parentRoute: typeof ProtectedImport
    }
    '/_auth/forgot-password/$token': {
      id: '/_auth/forgot-password/$token'
      path: '/forgot-password/$token'
      fullPath: '/forgot-password/$token'
      preLoaderRoute: typeof AuthForgotPasswordTokenImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sign-up/$token': {
      id: '/_auth/sign-up/$token'
      path: '/sign-up/$token'
      fullPath: '/sign-up/$token'
      preLoaderRoute: typeof AuthSignUpTokenImport
      parentRoute: typeof AuthImport
    }
    '/_auth/forgot-password/': {
      id: '/_auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sign-up/': {
      id: '/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpIndexImport
      parentRoute: typeof AuthImport
    }
    '/_protected/_dealership/dealership/notifications': {
      id: '/_protected/_dealership/dealership/notifications'
      path: '/dealership/notifications'
      fullPath: '/dealership/notifications'
      preLoaderRoute: typeof ProtectedDealershipDealershipNotificationsImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_dealership/dealership/payment-history': {
      id: '/_protected/_dealership/dealership/payment-history'
      path: '/dealership/payment-history'
      fullPath: '/dealership/payment-history'
      preLoaderRoute: typeof ProtectedDealershipDealershipPaymentHistoryImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_dealership/dealership/payment-methods': {
      id: '/_protected/_dealership/dealership/payment-methods'
      path: '/dealership/payment-methods'
      fullPath: '/dealership/payment-methods'
      preLoaderRoute: typeof ProtectedDealershipDealershipPaymentMethodsImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_dealership/dealership/profile': {
      id: '/_protected/_dealership/dealership/profile'
      path: '/dealership/profile'
      fullPath: '/dealership/profile'
      preLoaderRoute: typeof ProtectedDealershipDealershipProfileImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_dealership/dealership/subscription': {
      id: '/_protected/_dealership/dealership/subscription'
      path: '/dealership/subscription'
      fullPath: '/dealership/subscription'
      preLoaderRoute: typeof ProtectedDealershipDealershipSubscriptionImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_dealership/dealership/users': {
      id: '/_protected/_dealership/dealership/users'
      path: '/dealership/users'
      fullPath: '/dealership/users'
      preLoaderRoute: typeof ProtectedDealershipDealershipUsersImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_equipment/equipment/create': {
      id: '/_protected/_equipment/equipment/create'
      path: '/equipment/create'
      fullPath: '/equipment/create'
      preLoaderRoute: typeof ProtectedEquipmentEquipmentCreateImport
      parentRoute: typeof ProtectedEquipmentImport
    }
    '/_protected/_import/import/$id': {
      id: '/_protected/_import/import/$id'
      path: '/import/$id'
      fullPath: '/import/$id'
      preLoaderRoute: typeof ProtectedImportImportIdImport
      parentRoute: typeof ProtectedImportImport
    }
    '/_protected/_import/import/create': {
      id: '/_protected/_import/import/create'
      path: '/import/create'
      fullPath: '/import/create'
      preLoaderRoute: typeof ProtectedImportImportCreateImport
      parentRoute: typeof ProtectedImportImport
    }
    '/_protected/_leasing/leasing/$id': {
      id: '/_protected/_leasing/leasing/$id'
      path: '/leasing/$id'
      fullPath: '/leasing/$id'
      preLoaderRoute: typeof ProtectedLeasingLeasingIdImport
      parentRoute: typeof ProtectedLeasingImport
    }
    '/_protected/_leasing/leasing/create': {
      id: '/_protected/_leasing/leasing/create'
      path: '/leasing/create'
      fullPath: '/leasing/create'
      preLoaderRoute: typeof ProtectedLeasingLeasingCreateImport
      parentRoute: typeof ProtectedLeasingImport
    }
    '/_protected/_tax/tax/create': {
      id: '/_protected/_tax/tax/create'
      path: '/tax/create'
      fullPath: '/tax/create'
      preLoaderRoute: typeof ProtectedTaxTaxCreateImport
      parentRoute: typeof ProtectedTaxImport
    }
    '/_protected/_dealership/dealership/': {
      id: '/_protected/_dealership/dealership/'
      path: '/dealership'
      fullPath: '/dealership'
      preLoaderRoute: typeof ProtectedDealershipDealershipIndexImport
      parentRoute: typeof ProtectedDealershipImport
    }
    '/_protected/_equipment/equipment/': {
      id: '/_protected/_equipment/equipment/'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof ProtectedEquipmentEquipmentIndexImport
      parentRoute: typeof ProtectedEquipmentImport
    }
    '/_protected/_import/import/': {
      id: '/_protected/_import/import/'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ProtectedImportImportIndexImport
      parentRoute: typeof ProtectedImportImport
    }
    '/_protected/_leasing/leasing/': {
      id: '/_protected/_leasing/leasing/'
      path: '/leasing'
      fullPath: '/leasing'
      preLoaderRoute: typeof ProtectedLeasingLeasingIndexImport
      parentRoute: typeof ProtectedLeasingImport
    }
    '/_protected/_tax/tax/': {
      id: '/_protected/_tax/tax/'
      path: '/tax'
      fullPath: '/tax'
      preLoaderRoute: typeof ProtectedTaxTaxIndexImport
      parentRoute: typeof ProtectedTaxImport
    }
    '/_protected/_tax/tax/$id/': {
      id: '/_protected/_tax/tax/$id/'
      path: '/tax/$id'
      fullPath: '/tax/$id'
      preLoaderRoute: typeof ProtectedTaxTaxIdIndexImport
      parentRoute: typeof ProtectedTaxImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthForgotPasswordTokenRoute: typeof AuthForgotPasswordTokenRoute
  AuthSignUpTokenRoute: typeof AuthSignUpTokenRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthForgotPasswordTokenRoute: AuthForgotPasswordTokenRoute,
  AuthSignUpTokenRoute: AuthSignUpTokenRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ProtectedDealershipRouteChildren {
  ProtectedDealershipDealershipNotificationsRoute: typeof ProtectedDealershipDealershipNotificationsRoute
  ProtectedDealershipDealershipPaymentHistoryRoute: typeof ProtectedDealershipDealershipPaymentHistoryRoute
  ProtectedDealershipDealershipPaymentMethodsRoute: typeof ProtectedDealershipDealershipPaymentMethodsRoute
  ProtectedDealershipDealershipProfileRoute: typeof ProtectedDealershipDealershipProfileRoute
  ProtectedDealershipDealershipSubscriptionRoute: typeof ProtectedDealershipDealershipSubscriptionRoute
  ProtectedDealershipDealershipUsersRoute: typeof ProtectedDealershipDealershipUsersRoute
  ProtectedDealershipDealershipIndexRoute: typeof ProtectedDealershipDealershipIndexRoute
}

const ProtectedDealershipRouteChildren: ProtectedDealershipRouteChildren = {
  ProtectedDealershipDealershipNotificationsRoute:
    ProtectedDealershipDealershipNotificationsRoute,
  ProtectedDealershipDealershipPaymentHistoryRoute:
    ProtectedDealershipDealershipPaymentHistoryRoute,
  ProtectedDealershipDealershipPaymentMethodsRoute:
    ProtectedDealershipDealershipPaymentMethodsRoute,
  ProtectedDealershipDealershipProfileRoute:
    ProtectedDealershipDealershipProfileRoute,
  ProtectedDealershipDealershipSubscriptionRoute:
    ProtectedDealershipDealershipSubscriptionRoute,
  ProtectedDealershipDealershipUsersRoute:
    ProtectedDealershipDealershipUsersRoute,
  ProtectedDealershipDealershipIndexRoute:
    ProtectedDealershipDealershipIndexRoute,
}

const ProtectedDealershipRouteWithChildren =
  ProtectedDealershipRoute._addFileChildren(ProtectedDealershipRouteChildren)

interface ProtectedEquipmentRouteChildren {
  ProtectedEquipmentEquipmentCreateRoute: typeof ProtectedEquipmentEquipmentCreateRoute
  ProtectedEquipmentEquipmentIndexRoute: typeof ProtectedEquipmentEquipmentIndexRoute
}

const ProtectedEquipmentRouteChildren: ProtectedEquipmentRouteChildren = {
  ProtectedEquipmentEquipmentCreateRoute:
    ProtectedEquipmentEquipmentCreateRoute,
  ProtectedEquipmentEquipmentIndexRoute: ProtectedEquipmentEquipmentIndexRoute,
}

const ProtectedEquipmentRouteWithChildren =
  ProtectedEquipmentRoute._addFileChildren(ProtectedEquipmentRouteChildren)

interface ProtectedImportRouteChildren {
  ProtectedImportImportIdRoute: typeof ProtectedImportImportIdRoute
  ProtectedImportImportCreateRoute: typeof ProtectedImportImportCreateRoute
  ProtectedImportImportIndexRoute: typeof ProtectedImportImportIndexRoute
}

const ProtectedImportRouteChildren: ProtectedImportRouteChildren = {
  ProtectedImportImportIdRoute: ProtectedImportImportIdRoute,
  ProtectedImportImportCreateRoute: ProtectedImportImportCreateRoute,
  ProtectedImportImportIndexRoute: ProtectedImportImportIndexRoute,
}

const ProtectedImportRouteWithChildren = ProtectedImportRoute._addFileChildren(
  ProtectedImportRouteChildren,
)

interface ProtectedLeasingRouteChildren {
  ProtectedLeasingLeasingIdRoute: typeof ProtectedLeasingLeasingIdRoute
  ProtectedLeasingLeasingCreateRoute: typeof ProtectedLeasingLeasingCreateRoute
  ProtectedLeasingLeasingIndexRoute: typeof ProtectedLeasingLeasingIndexRoute
}

const ProtectedLeasingRouteChildren: ProtectedLeasingRouteChildren = {
  ProtectedLeasingLeasingIdRoute: ProtectedLeasingLeasingIdRoute,
  ProtectedLeasingLeasingCreateRoute: ProtectedLeasingLeasingCreateRoute,
  ProtectedLeasingLeasingIndexRoute: ProtectedLeasingLeasingIndexRoute,
}

const ProtectedLeasingRouteWithChildren =
  ProtectedLeasingRoute._addFileChildren(ProtectedLeasingRouteChildren)

interface ProtectedTaxRouteChildren {
  ProtectedTaxTaxCreateRoute: typeof ProtectedTaxTaxCreateRoute
  ProtectedTaxTaxIndexRoute: typeof ProtectedTaxTaxIndexRoute
  ProtectedTaxTaxIdIndexRoute: typeof ProtectedTaxTaxIdIndexRoute
}

const ProtectedTaxRouteChildren: ProtectedTaxRouteChildren = {
  ProtectedTaxTaxCreateRoute: ProtectedTaxTaxCreateRoute,
  ProtectedTaxTaxIndexRoute: ProtectedTaxTaxIndexRoute,
  ProtectedTaxTaxIdIndexRoute: ProtectedTaxTaxIdIndexRoute,
}

const ProtectedTaxRouteWithChildren = ProtectedTaxRoute._addFileChildren(
  ProtectedTaxRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedDealershipRoute: typeof ProtectedDealershipRouteWithChildren
  ProtectedEquipmentRoute: typeof ProtectedEquipmentRouteWithChildren
  ProtectedImportRoute: typeof ProtectedImportRouteWithChildren
  ProtectedLeasingRoute: typeof ProtectedLeasingRouteWithChildren
  ProtectedTaxRoute: typeof ProtectedTaxRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedPurchaseRoute: typeof ProtectedPurchaseRoute
  ProtectedRedirectToCustomerPortalRoute: typeof ProtectedRedirectToCustomerPortalRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDealershipRoute: ProtectedDealershipRouteWithChildren,
  ProtectedEquipmentRoute: ProtectedEquipmentRouteWithChildren,
  ProtectedImportRoute: ProtectedImportRouteWithChildren,
  ProtectedLeasingRoute: ProtectedLeasingRouteWithChildren,
  ProtectedTaxRoute: ProtectedTaxRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedPurchaseRoute: ProtectedPurchaseRoute,
  ProtectedRedirectToCustomerPortalRoute:
    ProtectedRedirectToCustomerPortalRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ProtectedTaxRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/login': typeof AuthLoginRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/purchase': typeof ProtectedPurchaseRoute
  '/redirect-to-customer-portal': typeof ProtectedRedirectToCustomerPortalRoute
  '/forgot-password/$token': typeof AuthForgotPasswordTokenRoute
  '/sign-up/$token': typeof AuthSignUpTokenRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/sign-up': typeof AuthSignUpIndexRoute
  '/dealership/notifications': typeof ProtectedDealershipDealershipNotificationsRoute
  '/dealership/payment-history': typeof ProtectedDealershipDealershipPaymentHistoryRoute
  '/dealership/payment-methods': typeof ProtectedDealershipDealershipPaymentMethodsRoute
  '/dealership/profile': typeof ProtectedDealershipDealershipProfileRoute
  '/dealership/subscription': typeof ProtectedDealershipDealershipSubscriptionRoute
  '/dealership/users': typeof ProtectedDealershipDealershipUsersRoute
  '/equipment/create': typeof ProtectedEquipmentEquipmentCreateRoute
  '/import/$id': typeof ProtectedImportImportIdRoute
  '/import/create': typeof ProtectedImportImportCreateRoute
  '/leasing/$id': typeof ProtectedLeasingLeasingIdRoute
  '/leasing/create': typeof ProtectedLeasingLeasingCreateRoute
  '/tax/create': typeof ProtectedTaxTaxCreateRoute
  '/dealership': typeof ProtectedDealershipDealershipIndexRoute
  '/equipment': typeof ProtectedEquipmentEquipmentIndexRoute
  '/import': typeof ProtectedImportImportIndexRoute
  '/leasing': typeof ProtectedLeasingLeasingIndexRoute
  '/tax': typeof ProtectedTaxTaxIndexRoute
  '/tax/$id': typeof ProtectedTaxTaxIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ProtectedTaxRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/login': typeof AuthLoginRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/purchase': typeof ProtectedPurchaseRoute
  '/redirect-to-customer-portal': typeof ProtectedRedirectToCustomerPortalRoute
  '/forgot-password/$token': typeof AuthForgotPasswordTokenRoute
  '/sign-up/$token': typeof AuthSignUpTokenRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/sign-up': typeof AuthSignUpIndexRoute
  '/dealership/notifications': typeof ProtectedDealershipDealershipNotificationsRoute
  '/dealership/payment-history': typeof ProtectedDealershipDealershipPaymentHistoryRoute
  '/dealership/payment-methods': typeof ProtectedDealershipDealershipPaymentMethodsRoute
  '/dealership/profile': typeof ProtectedDealershipDealershipProfileRoute
  '/dealership/subscription': typeof ProtectedDealershipDealershipSubscriptionRoute
  '/dealership/users': typeof ProtectedDealershipDealershipUsersRoute
  '/equipment/create': typeof ProtectedEquipmentEquipmentCreateRoute
  '/import/$id': typeof ProtectedImportImportIdRoute
  '/import/create': typeof ProtectedImportImportCreateRoute
  '/leasing/$id': typeof ProtectedLeasingLeasingIdRoute
  '/leasing/create': typeof ProtectedLeasingLeasingCreateRoute
  '/tax/create': typeof ProtectedTaxTaxCreateRoute
  '/dealership': typeof ProtectedDealershipDealershipIndexRoute
  '/equipment': typeof ProtectedEquipmentEquipmentIndexRoute
  '/import': typeof ProtectedImportImportIndexRoute
  '/leasing': typeof ProtectedLeasingLeasingIndexRoute
  '/tax': typeof ProtectedTaxTaxIndexRoute
  '/tax/$id': typeof ProtectedTaxTaxIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_protected': typeof ProtectedRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_protected/_dealership': typeof ProtectedDealershipRouteWithChildren
  '/_protected/_equipment': typeof ProtectedEquipmentRouteWithChildren
  '/_protected/_import': typeof ProtectedImportRouteWithChildren
  '/_protected/_leasing': typeof ProtectedLeasingRouteWithChildren
  '/_protected/_tax': typeof ProtectedTaxRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/purchase': typeof ProtectedPurchaseRoute
  '/_protected/redirect-to-customer-portal': typeof ProtectedRedirectToCustomerPortalRoute
  '/_auth/forgot-password/$token': typeof AuthForgotPasswordTokenRoute
  '/_auth/sign-up/$token': typeof AuthSignUpTokenRoute
  '/_auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/_auth/sign-up/': typeof AuthSignUpIndexRoute
  '/_protected/_dealership/dealership/notifications': typeof ProtectedDealershipDealershipNotificationsRoute
  '/_protected/_dealership/dealership/payment-history': typeof ProtectedDealershipDealershipPaymentHistoryRoute
  '/_protected/_dealership/dealership/payment-methods': typeof ProtectedDealershipDealershipPaymentMethodsRoute
  '/_protected/_dealership/dealership/profile': typeof ProtectedDealershipDealershipProfileRoute
  '/_protected/_dealership/dealership/subscription': typeof ProtectedDealershipDealershipSubscriptionRoute
  '/_protected/_dealership/dealership/users': typeof ProtectedDealershipDealershipUsersRoute
  '/_protected/_equipment/equipment/create': typeof ProtectedEquipmentEquipmentCreateRoute
  '/_protected/_import/import/$id': typeof ProtectedImportImportIdRoute
  '/_protected/_import/import/create': typeof ProtectedImportImportCreateRoute
  '/_protected/_leasing/leasing/$id': typeof ProtectedLeasingLeasingIdRoute
  '/_protected/_leasing/leasing/create': typeof ProtectedLeasingLeasingCreateRoute
  '/_protected/_tax/tax/create': typeof ProtectedTaxTaxCreateRoute
  '/_protected/_dealership/dealership/': typeof ProtectedDealershipDealershipIndexRoute
  '/_protected/_equipment/equipment/': typeof ProtectedEquipmentEquipmentIndexRoute
  '/_protected/_import/import/': typeof ProtectedImportImportIndexRoute
  '/_protected/_leasing/leasing/': typeof ProtectedLeasingLeasingIndexRoute
  '/_protected/_tax/tax/': typeof ProtectedTaxTaxIndexRoute
  '/_protected/_tax/tax/$id/': typeof ProtectedTaxTaxIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/redirect'
    | '/login'
    | '/dashboard'
    | '/purchase'
    | '/redirect-to-customer-portal'
    | '/forgot-password/$token'
    | '/sign-up/$token'
    | '/forgot-password'
    | '/sign-up'
    | '/dealership/notifications'
    | '/dealership/payment-history'
    | '/dealership/payment-methods'
    | '/dealership/profile'
    | '/dealership/subscription'
    | '/dealership/users'
    | '/equipment/create'
    | '/import/$id'
    | '/import/create'
    | '/leasing/$id'
    | '/leasing/create'
    | '/tax/create'
    | '/dealership'
    | '/equipment'
    | '/import'
    | '/leasing'
    | '/tax'
    | '/tax/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/redirect'
    | '/login'
    | '/dashboard'
    | '/purchase'
    | '/redirect-to-customer-portal'
    | '/forgot-password/$token'
    | '/sign-up/$token'
    | '/forgot-password'
    | '/sign-up'
    | '/dealership/notifications'
    | '/dealership/payment-history'
    | '/dealership/payment-methods'
    | '/dealership/profile'
    | '/dealership/subscription'
    | '/dealership/users'
    | '/equipment/create'
    | '/import/$id'
    | '/import/create'
    | '/leasing/$id'
    | '/leasing/create'
    | '/tax/create'
    | '/dealership'
    | '/equipment'
    | '/import'
    | '/leasing'
    | '/tax'
    | '/tax/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_protected'
    | '/redirect'
    | '/_auth/login'
    | '/_protected/_dealership'
    | '/_protected/_equipment'
    | '/_protected/_import'
    | '/_protected/_leasing'
    | '/_protected/_tax'
    | '/_protected/dashboard'
    | '/_protected/purchase'
    | '/_protected/redirect-to-customer-portal'
    | '/_auth/forgot-password/$token'
    | '/_auth/sign-up/$token'
    | '/_auth/forgot-password/'
    | '/_auth/sign-up/'
    | '/_protected/_dealership/dealership/notifications'
    | '/_protected/_dealership/dealership/payment-history'
    | '/_protected/_dealership/dealership/payment-methods'
    | '/_protected/_dealership/dealership/profile'
    | '/_protected/_dealership/dealership/subscription'
    | '/_protected/_dealership/dealership/users'
    | '/_protected/_equipment/equipment/create'
    | '/_protected/_import/import/$id'
    | '/_protected/_import/import/create'
    | '/_protected/_leasing/leasing/$id'
    | '/_protected/_leasing/leasing/create'
    | '/_protected/_tax/tax/create'
    | '/_protected/_dealership/dealership/'
    | '/_protected/_equipment/equipment/'
    | '/_protected/_import/import/'
    | '/_protected/_leasing/leasing/'
    | '/_protected/_tax/tax/'
    | '/_protected/_tax/tax/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  ProtectedRoute: typeof ProtectedRouteWithChildren
  RedirectRoute: typeof RedirectRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  ProtectedRoute: ProtectedRouteWithChildren,
  RedirectRoute: RedirectRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/_protected",
        "/redirect"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/forgot-password/$token",
        "/_auth/sign-up/$token",
        "/_auth/forgot-password/",
        "/_auth/sign-up/"
      ]
    },
    "/_protected": {
      "filePath": "_protected.tsx",
      "children": [
        "/_protected/_dealership",
        "/_protected/_equipment",
        "/_protected/_import",
        "/_protected/_leasing",
        "/_protected/_tax",
        "/_protected/dashboard",
        "/_protected/purchase",
        "/_protected/redirect-to-customer-portal"
      ]
    },
    "/redirect": {
      "filePath": "redirect.tsx"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_protected/_dealership": {
      "filePath": "_protected/_dealership.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/_dealership/dealership/notifications",
        "/_protected/_dealership/dealership/payment-history",
        "/_protected/_dealership/dealership/payment-methods",
        "/_protected/_dealership/dealership/profile",
        "/_protected/_dealership/dealership/subscription",
        "/_protected/_dealership/dealership/users",
        "/_protected/_dealership/dealership/"
      ]
    },
    "/_protected/_equipment": {
      "filePath": "_protected/_equipment.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/_equipment/equipment/create",
        "/_protected/_equipment/equipment/"
      ]
    },
    "/_protected/_import": {
      "filePath": "_protected/_import.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/_import/import/$id",
        "/_protected/_import/import/create",
        "/_protected/_import/import/"
      ]
    },
    "/_protected/_leasing": {
      "filePath": "_protected/_leasing.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/_leasing/leasing/$id",
        "/_protected/_leasing/leasing/create",
        "/_protected/_leasing/leasing/"
      ]
    },
    "/_protected/_tax": {
      "filePath": "_protected/_tax.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/_tax/tax/create",
        "/_protected/_tax/tax/",
        "/_protected/_tax/tax/$id/"
      ]
    },
    "/_protected/dashboard": {
      "filePath": "_protected/dashboard.tsx",
      "parent": "/_protected"
    },
    "/_protected/purchase": {
      "filePath": "_protected/purchase.tsx",
      "parent": "/_protected"
    },
    "/_protected/redirect-to-customer-portal": {
      "filePath": "_protected/redirect-to-customer-portal.tsx",
      "parent": "/_protected"
    },
    "/_auth/forgot-password/$token": {
      "filePath": "_auth/forgot-password.$token.tsx",
      "parent": "/_auth"
    },
    "/_auth/sign-up/$token": {
      "filePath": "_auth/sign-up.$token.tsx",
      "parent": "/_auth"
    },
    "/_auth/forgot-password/": {
      "filePath": "_auth/forgot-password.index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sign-up/": {
      "filePath": "_auth/sign-up.index.tsx",
      "parent": "/_auth"
    },
    "/_protected/_dealership/dealership/notifications": {
      "filePath": "_protected/_dealership/dealership.notifications.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_dealership/dealership/payment-history": {
      "filePath": "_protected/_dealership/dealership.payment-history.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_dealership/dealership/payment-methods": {
      "filePath": "_protected/_dealership/dealership.payment-methods.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_dealership/dealership/profile": {
      "filePath": "_protected/_dealership/dealership.profile.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_dealership/dealership/subscription": {
      "filePath": "_protected/_dealership/dealership.subscription.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_dealership/dealership/users": {
      "filePath": "_protected/_dealership/dealership.users.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_equipment/equipment/create": {
      "filePath": "_protected/_equipment/equipment.create.tsx",
      "parent": "/_protected/_equipment"
    },
    "/_protected/_import/import/$id": {
      "filePath": "_protected/_import/import.$id.tsx",
      "parent": "/_protected/_import"
    },
    "/_protected/_import/import/create": {
      "filePath": "_protected/_import/import.create.tsx",
      "parent": "/_protected/_import"
    },
    "/_protected/_leasing/leasing/$id": {
      "filePath": "_protected/_leasing/leasing.$id.tsx",
      "parent": "/_protected/_leasing"
    },
    "/_protected/_leasing/leasing/create": {
      "filePath": "_protected/_leasing/leasing.create.tsx",
      "parent": "/_protected/_leasing"
    },
    "/_protected/_tax/tax/create": {
      "filePath": "_protected/_tax/tax.create.tsx",
      "parent": "/_protected/_tax"
    },
    "/_protected/_dealership/dealership/": {
      "filePath": "_protected/_dealership/dealership.index.tsx",
      "parent": "/_protected/_dealership"
    },
    "/_protected/_equipment/equipment/": {
      "filePath": "_protected/_equipment/equipment.index.tsx",
      "parent": "/_protected/_equipment"
    },
    "/_protected/_import/import/": {
      "filePath": "_protected/_import/import.index.tsx",
      "parent": "/_protected/_import"
    },
    "/_protected/_leasing/leasing/": {
      "filePath": "_protected/_leasing/leasing.index.tsx",
      "parent": "/_protected/_leasing"
    },
    "/_protected/_tax/tax/": {
      "filePath": "_protected/_tax/tax.index.tsx",
      "parent": "/_protected/_tax"
    },
    "/_protected/_tax/tax/$id/": {
      "filePath": "_protected/_tax/tax.$id.index.tsx",
      "parent": "/_protected/_tax"
    }
  }
}
ROUTE_MANIFEST_END */
